import { Component, OnInit, Input, isDevMode } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MenuItem } from '../../models';

@Component({
  selector: 'left-sidebar',
  templateUrl: './left-sidebar.component.html',
  styleUrls: ['./left-sidebar.component.scss'],
  providers: []
})
export class LeftSidebarComponent implements OnInit {
  @Input() items: Array<MenuItem> = [{
    title: 'Forget to add <code>item</code> props???',
    id: 'forgot-to-add-props',
    icon: 'fas fa-bullseye'
  }, {
    title: 'This is an overly long menu item name but it wraps.',
    id: 'very-long-name',
    icon: 'fas fa-globe'
  }];
  @Input() currentRoute: string = '';
  currentItem: String = '';

  constructor(private router: Router,
    private activeRoute: ActivatedRoute) { }

  /**
   * On initialization, checks the route to properly highlight the correct menu
   * option.
   */
  ngOnInit() {
    this.syncCurrentItem();
  }

  ngOnChanges() {
    this.syncCurrentItem();
  }

  /**
   * @param item
   * @return True if the menu item matches the determined current item.
   */
  isActive(item): boolean {
    return this.currentItem === item.id;
  }

  /**
   * Determines if an item route is active.  This also allows for checking
   * multiple routes if `item.routes` is defined.
   * @param item
   * @todo Can do a better job of checking more than the route suffix...
   */
  isItemRouteActive(item): boolean {
    if (item.routeAliases) {
      return item.routeAliases.concat(item.route).reduce((res, route) => {
        if (res) {
          return res;
        }
        return this.isItemRouteActive({ route });
      }, false);
    }
    if (item.route) {
      let route: Array<Object|String> = Array.isArray(item.route) ?
        item.route : [item.route];
      const routeUrl = this.router.createUrlTree(route, {
        relativeTo: this.activeRoute
      });
      // This line checks if the route prefix matches...
      return this.currentRoute
        .slice(0, routeUrl.toString().length) === routeUrl.toString();
    } else {
      return false;
    }
  }

  onItemSelect(selectedItem: string) {
    this.currentItem = selectedItem;
  }

  syncCurrentItem() {
    // let activeRoutes = [];
    // TODO: What happens to this code segment when using multiple nested routers?
    // This will sync the active link with the active route, even if we just
    // navigated to this page.
    this.items.map((item) => {
      if (this.isItemRouteActive(item)) {
        // It's possible that we have multiple matches but this shouldn't occur.
        this.currentItem = item.id;
        // activeRoutes.push(item);
      }
    });

    if (isDevMode()) {
      // console.assert(activeRoutes.length <= 1,
      //   'Detected multiple left-sidebar routes given the provided set of'
      //   + ' items: ', JSON.stringify(activeRoutes));
    }
  }
}
